module.exports = __webpack_public_path__ + "static/media/googleplay.1589a493.png";